import React, { createContext, useContext, useState } from 'react';
import {ConsultationItem, ConsultationModalType} from "../../../../types/consultation";

const ConsultationModalContext = createContext<any>(null);

export function ConsultationModalProvider({ children }: { children: React.ReactNode }) {
    const [isConfirmModal, setIsConfirmModal] = useState(false);
    const [isEditModal, setIsEditModal] = useState(false);
    const [isConsultantModal, setIsConsultantModal] = useState(false);
    const [isReviewModal, setIsReviewModal] = useState(false);
    const [isCounselingReserve, setIsCounselingReserve] = useState(false);
    const [selectedConsultation, setSelectedConsultation] = useState<ConsultationItem | null>(null);

    const removeToggle = () => {
        setSelectedConsultation(null);
        setIsEditModal(false);
        setIsReviewModal(false);
        setIsConsultantModal(false);
        setIsConfirmModal(false);
    };

    const toggleModal = (
        {consultation, modalType}: { consultation : ConsultationItem | null, modalType:  ConsultationModalType}
    ) => {
        setSelectedConsultation(consultation);
        switch (modalType) {
            case ConsultationModalType.EDIT:
                return setIsEditModal(true);
            case ConsultationModalType.DETAIL:
                return setIsConfirmModal(true);
            case ConsultationModalType.INFO:
                return setIsConsultantModal(true);
            case ConsultationModalType.REVIEW:
                setIsReviewModal(true);
        }
    };

    const toggleReserveModal = (consultation: ConsultationItem | null) => {
        setIsCounselingReserve(prev => !prev);
        setSelectedConsultation(consultation);
    };

    const value = {
        modalStates: {
            isConfirmModal,
            isEditModal,
            isConsultantModal,
            isReviewModal,
            isCounselingReserve,
            selectedConsultation
        },
        modalActions: {
            toggleModal,
            removeToggle,
            setSelectedConsultation,
            setIsCounselingReserve,
            toggleReserveModal
        }
    };

    return (
        <ConsultationModalContext.Provider value={value}>
            {children}
        </ConsultationModalContext.Provider>
    );
}

// 기존 hook을 Context를 사용하도록 변경
export function useConsultationModals() {
    const context = useContext(ConsultationModalContext);
    if (!context) {
        throw new Error('useConsultationModals must be used within a ConsultationModalProvider');
    }
    return context;
}